import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";

import { deliveryProviderConfigurationsHttp } from "./delivery-provider-configurations-http";
import { DeliveryProviderConfiguration } from "../models/delivery-provider-configuration";

export const deliveryProviderConfigurationsCacheKeys = {
  deliveryProviderConfigurations: "deliveryProviderConfigurations",
};

export const useDeliveryProviderConfigurations = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery<DeliveryProviderConfiguration[], any>(
    [
      deliveryProviderConfigurationsCacheKeys.deliveryProviderConfigurations,
      organizationKeyName,
    ],
    () =>
      deliveryProviderConfigurationsHttp.getDeliveryProviderConfigurations(
        organizationKeyName
      ),
    { refetchOnWindowFocus: false }
  );
};

export const useUpdateDeliveryProviderConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation(
    deliveryProviderConfigurationsHttp.updateDeliveryProviderConfiguration,
    {
      onSuccess: async () => {
        await queryClient.refetchQueries(
          deliveryProviderConfigurationsCacheKeys.deliveryProviderConfigurations
        );
      },
    }
  );
};

export const useCreateDeliveryProviderConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation(
    deliveryProviderConfigurationsHttp.createDeliveryProviderConfiguration,
    {
      onSuccess: async () => {
        await queryClient.refetchQueries(
          deliveryProviderConfigurationsCacheKeys.deliveryProviderConfigurations
        );
      },
    }
  );
};

export const useDeleteDeliveryProviderConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation(
    deliveryProviderConfigurationsHttp.deleteDeliveryProviderConfiguration,
    {
      onSuccess: async () => {
        await queryClient.refetchQueries(
          deliveryProviderConfigurationsCacheKeys.deliveryProviderConfigurations
        );
      },
    }
  );
};
